import { createSelector } from 'reselect';


const ownUserState = (store) => store.user;
const userDetailsState = (store) => store.apps.teamManagement.userDetails;

export const containerSelector = createSelector(
  [userDetailsState, ownUserState],
  (filteredState, ownUser) => ({
    activity: filteredState.get('activity'),
    loading: filteredState.get('loading'),
    me: ownUser,
    teams: filteredState.get('teams'),
    tunnels: filteredState.get('tunnels'),
    user: filteredState.get('user'),
  }),
);
